export const DEFAULT_PAGE_SIZE = {
  page: 1,
  size: 10,
};

export const ADD = "add";
export const EDIT = "edit";
export const FAILED = "failed";
export const SUCCESS = "success";
export const ERROR = "ERROR";
export const LOADING = "LOADING";
export const SUCCESS_CODE = "00000";

export const USER_ROLES = [
  {
    value: 1,
    label: "Super Admin",
  },
  {
    value: 2,
    label: "Admin",
  },
  {
    value: 3,
    label: "Photographer",
  },
];
export const USER_ROLE = {
  super_admin: { label: "Super Admin", value: 1 },

  admin: {
    value: 2,
    label: "Admin",
  },

  photographer: {
    value: 3,
    label: "Photographer",
  },
};

export const POSE_CATEGORIES = [
  { key: "individual", label: "Individual" },
  { key: "siblings", label: "Sibling" },
  { key: "friends", label: "Friends" },
];

export const AVAILABLE_PACKAGE_CATEGORIES = [
  { value: "standard", label: "Standard" },
  { value: "combo", label: "Combo" },
  { value: "customized", label: "Customized" },
];

export const custom = 'customized';

export const SESSIONS_EXPIRED_TEXT = "lens_session_expired_0000";
export const SELECTED_COUNTRY = "selected_country";
export const DEFAULT_COUNTRY_NAME = "United Arab Emirates";

export const EXCEL_FILE_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
export const EXCEL_FILE = "application/vnd.ms-excel";
export const EXCEL_EXTENSSION = ".xlsx";
export const EXCEL_NAME = "student_bulk_upload_template.xlsx";
export const EXCEL_DESCRIPTION = "Excel Files";
export const DROPDOWN_CONSTANTS = {
  list: "list",
  dropdown: "dropdown",
};

export const DELIVERY_TYPE = {
  softCopy: 'Only Soft Copy Package',
  schoolPickup: 'School Pickup'
}

export const STUDENT_IMG =
  "https://www.rainbowschoolnellore.com/images/student-profile-1.jpg";
